import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Languages from './Languages'

import '../static/css/header.css';
//import logo from '/icon.png'

import { useTranslation } from 'react-i18next';

function Header() {
	const { t } = useTranslation();
	var detectedLanguage = window.location.pathname.split('/')[1];
	if(detectedLanguage == "en") {
		detectedLanguage = "";
	}

	return (
        <Navbar expand="lg" className="bg-body-tertiary tilesNavbar">
            <Container>

                <Navbar.Brand href={"/" + detectedLanguage}>
                    <img className="d-inline-block align-top logo" src="/icon.png" alt="Tiles"/>
                    <span>{t('name')}</span>
                    </Navbar.Brand>
                <Languages/>
                <a href="https://www.reddit.com/r/UnlimitedTiles/">
                    <img className="d-inline-block align-right reddit" src="/reddit.png" alt="Reddit"/>
                </a>
            </Container>
        </Navbar>
    );
}

export default Header;